<script setup lang="ts">
import { GlossaryRecommend } from '../types';
// 定义组件属性
const props = defineProps<{
    isM?: boolean
    // 推荐术语列表
    items?: GlossaryRecommend[]
}>();

// 是否有推荐术语
const hasRecommend = computed(() => props.items && props.items.length > 0);
</script>

<template>
  <section
    v-if="hasRecommend"
    :class="[isM ? 'mt-80px pb-32px px-16px' : 'mt-48px']"
  >
    <h2
      class="fw-600 c-[--gray-900]"
      :class="[isM ? 'text-display-xs-sb mb-24px text-center' : 'text-display-xs-sb mb-40px']"
    >
      {{ $t('glossary.recommended') }}
    </h2>
    <div
      class="grid"
      :class="[isM ? 'grid-cols-1 gap-16px' : 'grid-cols-3 gap-32px']"
    >
      <router-link
        v-for="item in items"
        :key="item.title"
        :to="item.link"
        class="flex flex-col bg-[--gray-50] "
        :class="[isM ? 'p-24px rd-12px' : 'p-32px rd-16px']"
      >
        <h3
          class="c-[--gray-900]"
          :class="[isM ? 'text-md-sb mb-10px' : 'text-lg-sb mb-16px']"
        >
          {{ item.title }}
        </h3>
        <p
          :class="[isM ? 'text-sm-r c-[--gray-500]' : 'text-md-r c-[--gray-800]']"
        >
          {{ item.description }}
        </p>
      </router-link>
    </div>
  </section>
</template>
/* AG: 2025-06-06 10:58:20 */
